var map = {
	"./About.vue": [
		"f820",
		"chunk-55fc2c2e"
	],
	"./Book.vue": [
		"8bf3",
		"chunk-009f797e"
	],
	"./CheckOut.vue": [
		"da3a",
		"chunk-6dec7ce8"
	],
	"./ContactUs.vue": [
		"e9bb",
		"chunk-c826c468"
	],
	"./Gallery.vue": [
		"0d77",
		"chunk-6ce845fe"
	],
	"./Home.vue": [
		"bb51",
		"chunk-0e4fb2a8"
	],
	"./Puno.vue": [
		"4bed",
		"chunk-52701eef"
	],
	"./RoomDetails.vue": [
		"6443",
		"chunk-2d0cf6b3"
	],
	"./Rooms.vue": [
		"b924",
		"chunk-7e095817"
	],
	"./StandBy.vue": [
		"418b",
		"chunk-21ff5bd3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;